import { RestSchemas } from '@/contexts/QueryProvider'
import { useAppContext } from '@/catalog-apps/hooks/useAppContext'
// import { json } from '../../../../../mock-data/file-requirements/file-requirement-response.json'
import { useSuspenseQuery } from '@tanstack/react-query'
import { ENDPOINTS } from '@/util'

type FileRequirementsResponse = RestSchemas['Messages.Storage.FileRequirements']

// const mockData = json as FileRequirementsResponse

const getFileRequirements = async ({ appId, templateId }: { appId: number; templateId: number }) => {
  if (!appId || !templateId) {
    throw new Error('Missing required parameters')
  }
  const token = JSON.parse(sessionStorage.getItem('token') || '')
  if (!token) {
    throw new Error('No token found')
  }
  // return mockData
  const searchParams = new URLSearchParams({
    applicationId: appId.toString(),
    templateId: templateId.toString(),
  })
  const url = `${ENDPOINTS.LANDING}/storage/fileRequirements?${searchParams.toString()}`
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-type': 'application/json', Authorization: `Bearer ${token}` },
  })
  const data = await response.json()
  if (response.ok) {
    return data as FileRequirementsResponse
  }
  throw new Error('Failed to fetch file requirements')
}

export function useGetFileRequirements({ entityId, templateId }: { entityId: number; templateId: number }) {
  const { appId } = useAppContext()

  return useSuspenseQuery({
    queryKey: ['file-requirements', entityId, templateId],
    queryFn: () => getFileRequirements({ appId: appId!, templateId }),
  })
}
